import { render } from "./SidebarNavigation.vue?vue&type=template&id=18854517&scoped=true"
import script from "./SidebarNavigation.vue?vue&type=script&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&lang=js"

import "./SidebarNavigation.vue?vue&type=style&index=0&id=18854517&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18854517"]])

export default __exports__